import * as React from 'react'
import { IControlProps } from './types'
import {
  alpha,
  createStyles,
  Input,
  makeStyles,
  Theme
} from '@material-ui/core'
import { IFormula, IFormulaRow } from '../../models/Formula'
import { COLOURS, IControlColor } from './colours'
export interface IFormulaControlProps extends IControlProps {
  formula: IFormula
}

interface IFormulaStyleProps {
  controlColor: IControlColor
}

const useStyles = makeStyles<Theme, IFormulaStyleProps>((theme: Theme) =>
  createStyles({
    formulaAnswer: {
      color: (props) => props.controlColor.foreground,
      background: (props) => props.controlColor.background
    },

    formulaInfo: {
      marginTop: 12,
      padding: 8,
      backgroundColor: alpha(theme.palette.primary.light, 0.05),
      border: alpha(theme.palette.primary.light, 0.2),
      borderRadius: 4,
      fontSize: 12
    }
  })
)

const FormulaControl: React.FC<IFormulaControlProps> = (
  props: IFormulaControlProps
) => {
  const matchingRow = props.field.value
    ? props.formula.formulaRows.find(
        (row: IFormulaRow) => row.resultAnswer === props.field.value
      )
    : undefined

  const controlColor =
    (matchingRow && matchingRow.color && COLOURS[matchingRow.color]) ||
    COLOURS['white']

  const classes = useStyles({ controlColor })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.form.setFieldValue(props.field.name, event.target.value)
  }

  const questionLabels = props.formula.inputQuestions
    .map((question) => question.questionLabel || '')
    .filter((label) => label !== '')
    .map((label) => `"${label}"`)

  const inputQuestionLabels =
    questionLabels.length > 0
      ? questionLabels.join(' and ')
      : 'inputs questions'

  return (
    <div>
      <div className={classes.formulaAnswer}>
        <Input
          id={props.id}
          fullWidth
          value={(props.field.value as string) || ''}
          onChange={handleChange}
          disabled={true}
          placeholder={props.placeholder || ''}
          inputProps={{ style: { color: controlColor.foreground } }}
        />
      </div>
      <div className={classes.formulaInfo}>
        Calculated from: {inputQuestionLabels}
      </div>
    </div>
  )
}

export default FormulaControl
